/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Preferred_CommunicationInputs */

const cs_form_preferred_communication = /** @type {(inputs: Form_Preferred_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferovaná komunikace`)
};

const en_form_preferred_communication = /** @type {(inputs: Form_Preferred_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred communication`)
};

/**
* | output |
* | --- |
* | "Preferred communication" |
*
* @param {Form_Preferred_CommunicationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_preferred_communication = /** @type {((inputs?: Form_Preferred_CommunicationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Preferred_CommunicationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_preferred_communication(inputs)
	return cs_form_preferred_communication(inputs)
});